import React from "react";
import Waypoint from "react-waypoint";
import classnames from "classnames";

export default class StickNav extends React.Component {
    constructor(props) {
        super(props);
        let className = "";
        this.state = {
            className
        };
    }

    onEnter = evt => {
        this.setState({ className: "" });
    };

    onLeave = evt => {
        this.setState({ className: this.props.stuckClass });
    };

    onPositionChange = evt => {
        if (evt.currentPosition && !evt.previousPosition) {

            if (evt.currentPosition != "inside") {
                this.setState({
                    className: this.props.stuckClass
                });
            }
        }
    };

    render() {
        let className = classnames("sticky-nav", this.state.className);
        return (
            <div className="sticky-nav-wrapper">
                <div className={className}>{this.props.children}</div>
                <Waypoint
                    onEnter={this.onEnter}
                    onLeave={this.onLeave}
                    onPositionChange={this.onPositionChange}
                />
            </div>
        );
    }
}

StickNav.defaultProps = {
    stuckClass: "stuck"
};
